import axios from 'axios'

const BASE_URL = 'https://control.zjwec.cn'

// 新增/修改（有id走更新，无id走新增）
export function upsertBatchUser(data) {
  const method = data && data.id ? 'PUT' : 'POST'
  return axios({
    url: BASE_URL + '/api/batchuser',
    method: method,
    data: data
  }).then(function(res) {
    return res.data
  })
}

// 批量按idsname查询（不存在自动创建）
export function queryByNames(idsnameList) {
  return axios.post(BASE_URL + '/api/batchuser/queryByNames', idsnameList).then(function(res) {
    return res.data
  })
}

// 批量按idsname删除
export function deleteByNames(idsnameList) {
  return axios.post(BASE_URL + '/api/batchuser/deleteByNames', idsnameList).then(function(res) {
    return res.data
  })
}


// WEBPACK FOOTER //
// ./src/api/modules/batchuser.js